<app-main-layout>
  <app-expense-directory-page></app-expense-directory-page>
</app-main-layout>
